import {WebGl2Settings} from "#webgl2/settings"

export const checkForGlError = (gl: WebGL2RenderingContext, attempt?: string) => {
    if (WebGl2Settings.FrequentGlErrorChecking) {
        const lastError = gl.getError()
        if (lastError !== gl.NO_ERROR) {
            throw Error(`GL Error: ${lastError}${attempt ? ` (${attempt})` : ""}`)
        }
    }
}
